/**
 * Fixed pixel widths for carousel tile images at each design breakpoint.
 * Breakpoints: 375px → 348px, 768px → 256px, 1280px → 256px, 1536px → 288px.
 * Used by both product and category carousel tiles to keep image hints in sync
 * with the fixed-width CarouselItem layout.
 */
export const carouselItemImageWidths = ['348px', '256px', '256px', '288px'];

/** Aspect ratio (width / height) for product tiles inside the product carousel. */
export const productCarouselItemAspectRatio = 0.8;
